module.exports = __webpack_public_path__ + "img/9788990794932.59227bfc.jpg";